(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soyul-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const shell = document.querySelector('[data-soyul-header-shell]');
    if (!shell || shell.dataset.ready === 'true') return;
    shell.dataset.ready = 'true';

    const header = shell.querySelector('[data-soyul-header]');
    const menu = shell.querySelector('[data-soyul-menu]');
    const close = shell.querySelector('[data-soyul-close]');
    const announcement = shell.querySelector('[data-soyul-announcement]');
    let ticking = false;

    if (announcement) {
      const slides = [...announcement.querySelectorAll('[data-soyul-announcement-slide]')];
      const viewport = announcement.querySelector('.soyul-announcement__viewport');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let announcementIndex = 0;
      let announcementTimer;
      let interactionPaused = false;

      const showAnnouncement = (nextIndex, manual = false) => {
        announcementIndex = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const active = index === announcementIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.querySelectorAll('a').forEach(link => link.tabIndex = active ? 0 : -1);
        });
        viewport?.setAttribute('aria-live', manual ? 'polite' : 'off');
        if (manual) setTimeout(() => viewport?.setAttribute('aria-live', 'off'), 500);
      };

      const stopAnnouncements = () => clearTimeout(announcementTimer);
      const scheduleAnnouncements = () => {
        stopAnnouncements();
        if (reducedMotion.matches || interactionPaused || document.hidden || slides.length < 2) return;
        announcementTimer = setTimeout(() => {
          showAnnouncement(announcementIndex + 1);
          scheduleAnnouncements();
        }, 6000);
      };
      announcement.querySelector('[data-soyul-announcement-prev]')?.addEventListener('click', () => { showAnnouncement(announcementIndex - 1, true); scheduleAnnouncements(); });
      announcement.querySelector('[data-soyul-announcement-next]')?.addEventListener('click', () => { showAnnouncement(announcementIndex + 1, true); scheduleAnnouncements(); });
      announcement.addEventListener('mouseenter', () => { interactionPaused = true; stopAnnouncements(); });
      announcement.addEventListener('mouseleave', () => { interactionPaused = false; scheduleAnnouncements(); });
      announcement.addEventListener('focusin', () => { interactionPaused = true; stopAnnouncements(); });
      announcement.addEventListener('focusout', event => {
        if (announcement.contains(event.relatedTarget)) return;
        interactionPaused = false;
        scheduleAnnouncements();
      });
      document.addEventListener('visibilitychange', scheduleAnnouncements);
      showAnnouncement(0);
      scheduleAnnouncements();
    }

    const setMeasurements = () => {
      document.body.style.setProperty('--soyul-announcement-height', `${shell.querySelector('.soyul-announcement')?.offsetHeight || 30}px`);
      document.body.style.setProperty('--header-height', `${header?.offsetHeight || 68}px`);
      document.body.style.setProperty('--header-group-height', `${shell.offsetHeight}px`);
    };

    const updateHeader = () => {
      ticking = false;
      shell.classList.toggle('is-scrolled', window.scrollY > 24);
    };

    const requestHeaderUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateHeader);
    };

    close?.addEventListener('click', () => menu?.removeAttribute('open'));
    menu?.addEventListener('toggle', () => {
      document.documentElement.classList.toggle('soyul-menu-open', menu.open);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') menu?.removeAttribute('open');
    });
    window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
    window.addEventListener('resize', setMeasurements, { passive: true });
    setMeasurements();
    updateHeader();
  })();

  } catch(e) { console.error(e); }
})();
})();
